// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"186":"edf42f5b","887":"56a372f0","968":"ec97acf4"}[chunkId] + ".css";
};